<div class="search-field search-select">
    <select (change)="search()" [(ngModel)]="subjectSearch" class="select-field">
        <option [ngValue]="null">Alle Fächer</option>
        @for (subject of subjects; track subject) {
            <option [ngValue]="subject.id">{{ subject.name }}</option>
        }
    </select>
</div>

<div class="search-field search-select">
    <select (change)="search()" [(ngModel)]="schoolGradeSearch" class="select-field">
        <option [ngValue]="null">Alle Schulstufen</option>
        @for (grade of schoolGrades; track grade) {
            <option [ngValue]="grade">{{ grade }}. Klasse</option>
        }
    </select>
</div>

<div class="search-field search-input">
    <input (keyup)="search()" [(ngModel)]="titleSearch" class="input-field" placeholder="Titel..." type="text"/>
    <span class="search-icon">
    @if (!titleSearch) {
        <i class="fa fa-search"></i>
    }
        @if (titleSearch) {
            <i (click)="titleSearch='';search();" class="fa fa-times-circle"></i>
        }
  </span>
</div>
